// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3MH22","header":"ReportDetails_header__12kg2","title":"ReportDetails_title__2-hJ_","left":"ReportDetails_left__10FoX"};